<template>
  <v-card v-if="!hideModal" class="mb-4 mt-6 mt-md-4 elevation-6">
    <v-row align="center">
      <v-col cols="3" class="shrink py-0 align-self-end text-left hidden-sm-and-down">
        <v-img
          src="@/assets/img/banner-left.png"
          max-height="240"
          contain
          style="border-radius: 8px 0px 0px 8px;"
        />
      </v-col>
      <v-col class="grow py-8 px-md-3 px-sm-4 text-center">
        <h2 class="pb-2 px-2" style="line-height: 2.6rem;">{{ $t('WELCOME.TITLE') }}</h2>
        <p class="px-2">{{ $t('WELCOME.DESCRIPTION') }}</p>
      </v-col>
      <v-col cols="3" class="shrink py-0 text-right hidden-sm-and-down">
        <v-img
          src="@/assets/img/banner-right.png"
          max-height="240"
          contain
          style="border-radius: 0px 8px 8px 0px;"
        />
      </v-col>
    </v-row>
    <v-btn
      class="close_fab white"
      icon
      fab
      x-small
      elevation="2"
      light
      @click="hide()"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-card>
</template>

<style scoped>
.elevation-6 {
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06) !important;
}
.v-card {
  background-color: #FFF9E7;
  position: relative;
}

h2 {
  font-size: 42px;
}

.close_fab {
  position: absolute;
  top: -12px;
  right: -12px;
}

>>>.text-right .v-image__image {
    background-position-x: right !important;
}
>>>.text-left .v-image__image {
    background-position-x: left !important;
}
</style>

<script>
export default {
  name: 'WelcomeModal',
  data: () => ({
    hideModal: false,
  }),
  methods: {
    hide() {
      this.$track('close_hero', 'home');
      this.hideModal = true;
      localStorage.setItem('closed_welcome_modal', true);
    },
  },
  created() {
    this.hideModal = !!localStorage.getItem('closed_welcome_modal');
  },
};
</script>
